import API from '@/api';
import moment from 'moment';
const Medication = API.get('Medication');


function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export default ({
  namespaced: true,
  state: {
    id: null,
    medicine_id: null,
    generic: '',
    brand: '',
    strength: '',
    quantity: '',
    record_type: '',
    created_on: '',
    medication_index: '',

    // instruction
    instructionAlt: '', // alternative
    takeQuantity: '',
    takeLabel: '',
    everyQuantity: '',
    everyLabel: '',
    forQuantity: '',
    forLabel: '',
    // comment: '',
    medications: [],
    active: null,
    activeIndex: null,
    removed_items: []
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  getters: {
    medicine_id: state => state.medicine_id,
    generic: state => state.generic,
    brand: state => state.brand,
    strength: state => state.strength,
    quantity: state => state.quantity,
    record_type: state => state.record_type,
    created_on: state => state.created_on,
    medication_index: state => state.medication_index,

    /* ################################################## METHOD SEPARATORS ################################################## */
    
    instruction: state => {
      // instruction in paragraph form
      var instruction = ''
      if (state.instructionAlt)
        instruction = state.instructionAlt
      else
        instruction = `Take ${state.takeQuantity} ${state.takeLabel} every ${state.everyQuantity} ${state.everyLabel} for ${state.forQuantity} ${state.forLabel}`
      return instruction
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    instructionAlt: state => state.instructionAlt,
    // instruction
    takeQuantity: state => state.takeQuantity,
    takeLabel: state => state.takeLabel,
    everyQuantity: state => state.everyQuantity,
    everyLabel: state => state.everyLabel,
    forQuantity: state => state.forQuantity,
    forLabel: state => state.forLabel,
    // comment: state => state.comment,
    medications: state => state.medications,
    active: state => state.active,
    activeIndex: state => state.activeIndex,
    removed_items: state => state.removed_items
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  mutations: {
    updateMedicineId(state, id) {
      state.medicine_id = id
    },

    updateGeneric(state, generic) {
      state.generic = generic
    },

    updateBrand(state, brand) {
      state.brand = brand
    },

    updateStrength(state, strength) {
      state.strength = strength
    },

    updateQuantity(state, quantity) {
      state.quantity = quantity
    },

    // instruction
    updateInstructionAlt(state, value) {
      state.instructionAlt = value
    },

    updateTakeQuantity(state, value) {
      state.takeQuantity = value
    },

    updateTakeLabel(state, value) {
      state.takeLabel = value
    },

    updateEveryQuantity(state, value) {
      state.everyQuantity = value
    },

    updateEveryLabel(state, value) {
      state.everyLabel = value
    },

    updateForQuantity(state, value) {
      state.forQuantity = value
    },

    updateForLabel(state, value) {
      state.forLabel = value
    },

    // updateComment(state, value) {
    //   state.comment = value
    // },

    add(state) {
      var instruction

      if (state.instructionAlt) {
        instruction = state.instructionAlt
      } else {
        instruction = {
          sentence: `Take ${state.takeQuantity} ${state.takeLabel} every ${state.everyQuantity} ${state.everyLabel} for ${state.forQuantity} ${state.forLabel}`,
          take: {
            quantity: state.takeQuantity,
            label: state.takeLabel
          },
          every: {
            quantity: state.everyQuantity,
            label: state.everyLabel
          },
          for: {
            quantity: state.forQuantity,
            label: state.forLabel
          },
          // comment: state.comment
        }
      }

      let medication_index = null;
      if(state.medications[state.medications.length - 1]) {
        medication_index = state.medications[state.medications.length - 1].medication_index + 1;
      } else {
        medication_index = 0;
      }
      
      var medication = {
        id: null,
        medicine_id: state.medicine_id,
        generic: state.generic,
        brand: state.brand,
        strength: state.strength,
        quantity: state.quantity,
        date: moment().format('MMM. D, YYYY, h:mmA'),
        instruction: instruction,
        created_on: null,
        record_type: "current",

        // work around with pagination issue
        medication_index
      }

      console.log("added", medication);
      state.medications.push(medication)
      console.log(state.medications);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    clear(state) {
      state.id = null
      state.medicine_id = null
      state.generic = ''
      state.brand = ''
      state.strength = ''
      state.quantity = ''
      state.record_type = ''
      state.takeQuantity = ''
      state.takeLabel = ''
      state.everyQuantity = ''
      state.everyLabel = ''
      state.forQuantity = ''
      state.forLabel = ''
      state.instructionAlt = ''
      // state.comment = ''
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    edit(state) {
      var instruction

      if (state.instructionAlt) {
        instruction = state.instructionAlt
      } else {
        instruction = {
          sentence: `Take ${state.takeQuantity} ${state.takeLabel} every ${state.everyQuantity} ${state.everyLabel} for ${state.forQuantity} ${state.forLabel}`,
          take: {
            quantity: state.takeQuantity,
            label: state.takeLabel
          },
          every: {
            quantity: state.everyQuantity,
            label: state.everyLabel
          },
          for: {
            quantity: state.forQuantity,
            label: state.forLabel
          },
          // comment: state.comment
        }
      }
      var medication = {
        id: state.id,
        medicine_id: state.medicine_id,
        generic: state.generic,
        brand: state.brand,
        strength: state.strength,
        quantity: state.quantity,
        instruction: instruction,
        record_type: state.record_type,
        medication_index: state.medication_index
      }

      state.medications.splice(state.activeIndex, 1, medication);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setActive(state, index) {
      // work around with pagination issue
      var target = state.medications.findIndex( medication => medication.medication_index === index );
      var medication = state.medications[target];

      state.id = medication.id
      state.medicine_id = medication.medicine_id
      state.generic = medication.generic
      state.brand = medication.brand
      state.strength = medication.strength
      state.quantity = medication.quantity
      state.record_type = medication.record_type
      state.medication_index = medication.medication_index

      if (typeof medication.instruction == 'string') {
        state.instructionAlt = medication.instruction
        state.takeQuantity = ''
        state.takeLabel = ''
        state.everyQuantity = ''
        state.everyLabel = ''
        state.forQuantity = ''
        state.forLabel = ''
      } else {
        state.takeQuantity = medication.instruction.take.quantity
        state.takeLabel = medication.instruction.take.label
        state.everyQuantity = medication.instruction.every.quantity
        state.everyLabel = medication.instruction.every.label
        state.forQuantity = medication.instruction.for.quantity
        state.forLabel = medication.instruction.for.label
        state.instructionAlt = ''
      }
      // state.comment = medication.instruction.comment
      state.activeIndex = index;

      console.log(state.medications);
      console.log(state.medications[index]);
      console.log("medication record type: ", state.record_type);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    remove(state) {
      var index = state.activeIndex
      var target = state.medications.findIndex( medication => medication.medication_index === index );

      var item = state.medications[target]
      if (item.id !== null)
        state.removed_items.push(item)
      state.medications.splice(target, 1);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    loadSavedData(state, medications) {
      state.medications = [];

      console.log("medication load data");
      console.log(medications);

      medications.forEach(async (medication, index) => {
        
        var instruction = {};
        console.log("medication: ", index);
        
        instruction.take = {};
        instruction.take.quantity;
        instruction.take.label;
        
        instruction.every = {};
        instruction.every.quantity;
        instruction.every.label;
        
        instruction.for = {};
        instruction.for.quantity;
        instruction.for.label;



        if(medication.note || medication.instruction) {
          if (medication.note) {
            instruction = medication.note
          } else {
            let isJson = IsJsonString(medication.instruction);
            console.log("is json: ", isJson);
            if(isJson) {
              
              let parsed_instruction = JSON.parse(medication.instruction);

              if(parsed_instruction.take) {
                instruction = parsed_instruction;           
              } else {
                instruction = parsed_instruction.sentence;
              }

            } else {
              instruction = medication.instruction;
            }
          }
        }

        let quantity_data = "N/A";
        if(medication.quantity) {
          quantity_data = medication.quantity;
        }

        const data = {
          id: medication.id,
          medicine_id: medication.medicine_id,
          brand: medication.brand_name,
          generic: medication.generic_name,
          strength: medication.strength,
          quantity: quantity_data,
          date: moment(medication.created_at).format('MMM. D, YYYY, h:mmA'),
          instruction: instruction,
          note: medication.note,
          created_on: medication.pms_created_on,
          record_type: medication.record_type,

          // work around for pagination issue
          medication_index: index,
        }

        state.medications.push(data);
        console.log("[medication data]", state.medications);
      });
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    clearStoreData(state) {
      state.id = null;
      state.medicine_id = null;
      state.generic = '';
      state.brand = '';
      state.strength = '';
      state.quantity = '';
      state.record_type = '';
      state.takeQuantity = '';
      state.takeLabel = '';
      state.everyQuantity = '';
      state.everyLabel = '';
      state.forQuantity = '';
      state.forLabel = '';
      state.instructionAlt = ''
      // state.comment = '';
      state.medications = [];
      state.active = null;
      state.activeIndex = null;
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setMedicationId(state, {index, id}) {
      state.medications[index].id = id
    }
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  actions: {
    async save({ commit, getters }, {case_id, consult_id}) {
      getters.medications.forEach(async (medication, key) => {
        const payload = {
          brand_name: medication.brand,
          generic_name: medication.generic,
          strength: medication.strength,
          quantity: medication.quantity,
          medicine_id: medication.medicine_id,
        }
        console.log({ instruction: medication.instruction })
        if (typeof medication.instruction == 'string') {
          payload.note = medication.instruction
          payload.instruction = JSON.stringify({ sentence: medication.instruction })
        } else {
          payload.instruction = JSON.stringify(medication.instruction)
        }
        
          let response
          if (medication.id == null) {
            payload.patient_case_id = case_id
            payload.case_consultation_id = consult_id
            response = await Medication.create(payload);
            console.log("[medication/save]", response, key, response.data.id);
            // fix to avoid duplicate saved data on second save
            commit('setMedicationId', { index: key, id: response.data.id })
          } else {
            response = await Medication.update(medication.id, payload);
            console.log("[medication/update]", response, medication.brand_name, medication.id);
          }
      });

      // delete removed items
      if (getters.removed_items.length) {
        getters.removed_items.forEach(async medication => {
          let response = await Medication.delete(medication.id);
          console.log("[medication/delete_removed_items]", response);
        });
      }
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async compiled_medications({ getters }, {case_id}) {
      let compiled_medications = [];

      getters.medications.forEach(async (medication) => {
          const payload = {
            id:                 medication.id,
            brand_name:         medication.brand,
            generic_name:       medication.generic,
            strength:           medication.strength,
            quantity:           medication.quantity,
            medicine_id:        medication.medicine_id,
            note:               medication.note,
            record_type:        medication.record_type,
            patient_case_id:    case_id
          }
        
          if (typeof medication.instruction == 'string') {
            payload.note = medication.instruction
            payload.instruction = JSON.stringify({ sentence: medication.instruction })
          } else {
            payload.instruction = JSON.stringify(medication.instruction)
          }    

          compiled_medications.push(payload);
      });

      return compiled_medications;
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async delete(state, medications) {
      if (medications) {
        medications.forEach(async medication => {
          let response = await Medication.delete(medication.id);
          console.log("[medication/delete]", response);
        });
      }
    },
  }
})